/**
 * ASST.1 — client page context. Only route / entity_type / entity_id.
 * Tenant and role are never sent.
 */

const ENTITY_RULES = [
  {
    re: /^\/orders\/([^/]+)\/items\/([^/]+)/,
    route: "/orders/:orderId/items/:id",
    entity_type: "order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/orders\/([^/]+)/,
    route: "/orders/:id",
    entity_type: "order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/draft-orders\/([^/]+)/,
    route: "/draft-orders/:id",
    entity_type: "order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/admin-draft-orders\/([^/]+)/,
    route: "/admin-draft-orders/:id",
    entity_type: "order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/sales-orders\/([^/]+)/,
    route: "/sales-orders/:id",
    entity_type: "sales_order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/quotes\/new$/,
    route: "/quotes/new",
  },
  {
    re: /^\/quotes\/([^/]+)/,
    route: "/quotes/:id",
    entity_type: "quote",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/customers\/([^/]+)/,
    route: "/customers/:id",
    entity_type: "customer",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/blanks\/([^/]+)/,
    route: "/products/blanks/:blankId",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/new-product\/([^/]+)/,
    route: "/products/new-product/:id",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/(?!new-product|edit-product|blanks|sticker|poster|roll-label|sticker-sheet|new-necklace|nester|bulk-create|csv-upload|third-party)([^/]+)\/([^/]+)\/details$/,
    route: "/products/:id/:productId/details",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/edit-product\/([^/]+)/,
    route: "/products/edit-product/:id/:productId",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/(?:sticker|poster|roll-label|sticker-sheet|new-necklace|nester)\/([^/]+)/,
    route: "/products/:kind/:id",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/products\/(?!new$|new-product|bulk-create|blanks|csv-upload|third-party)([^/]+)$/,
    route: "/products/:id",
    entity_type: "product",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/purchase-order\/([^/]+)/,
    route: "/purchase-order/:id",
    entity_type: "purchase_order",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/batches\/([^/]+)/,
    route: "/batches/:id",
    entity_type: "batch",
    entity_id: (m) => m[1],
  },
  {
    re: /^\/inbox\/([^/]+)/,
    route: "/inbox/:conversationId",
    entity_type: "conversation",
    entity_id: (m) => m[1],
  },
];

const LIST_ROUTES = new Set([
  "/orders",
  "/draft-orders",
  "/unsynced-orders",
  "/late-orders",
  "/products",
  "/products/blanks",
  "/shops",
  "/quotes",
  "/sales-orders",
  "/customers",
  "/inbox",
  "/pricing",
  "/pos",
  "/settings",
  "/integrations",
  "/add-shop",
]);

export const resolveAssistPageContext = (pathname) => {
  const path = String(pathname || "").split("?")[0] || "/";
  for (const rule of ENTITY_RULES) {
    const match = path.match(rule.re);
    if (!match) continue;
    const ctx = { route: rule.route };
    if (rule.entity_type) ctx.entity_type = rule.entity_type;
    if (rule.entity_id) ctx.entity_id = String(rule.entity_id(match));
    return ctx;
  }
  if (path.startsWith("/settings")) {
    return { route: path };
  }
  if (LIST_ROUTES.has(path)) {
    return { route: path };
  }
  return { route: path };
};
